import React, { Component, useEffect, useState } from "react";

//custom
import moment from "moment";
//import axios
import axios from "axios";

//utils
import {
  check_authorized,
  signoutuser_confirm,
  isloginuser,
  signoutuser,
  getuniquedeviceid,
  get_userseckey,
} from "../../utils/Helper/CheckAuth";
import {
  showLoading,
  stopLoading,
  gotomyprofile,
  sent_clean_var,
  fun_input_focus,
  gotoeditprofile,
} from "../../utils/Helper/JSHelper";
import CallURL from "../../utils/API/CallURL";

//components
import Navigation from "../../components/Navigation/Navigation";
import ContactUs from "../../components/ContactUs/ContactUs";

function MyProfile() {
  //temp variable
  const [list_temp_load, set_list_temp_load] = useState([]);

  //myprofile variable
  const [profile_lastprofileup, set_profile_lastprofileup] = useState("");
  const [profile_fullname, set_profile_fullname] = useState("");
  const [profile_mobile, set_profile_mobile] = useState("");
  const [profile_accvalidtill, set_profile_accvalidtill] = useState("");
  const [profile_entrytime, set_profile_entrytime] = useState("");
  const [profile_lastaccess, set_profile_lastaccess] = useState("");

  //starting on mount
  useEffect(() => {
    //change background color
    document.body.style = "background: white;";

    //isloginuser
    if (isloginuser()) {
      //load my profile
      load_my_profile();
    }

    //if login check_authorized
    check_authorized("user");
  }, [list_temp_load]);

  function load_my_profile() {
    //showLoading
    showLoading();
    // Create an object of formData
    const formData = new Object();
    // Update the formData object
    formData.secuserkey = get_userseckey();
    formData.deviceid = getuniquedeviceid();
    // Send formData object
    axios
      .post(CallURL.load_my_profile, formData)
      .then((response) => {
        //stopLoading
        stopLoading();
        //console.log(response);
        //alert(response.data.apires);
        if (response.data.apires == "unauthorized") {
          //make logout
          signoutuser();
        } else if (response.data.apires == "success") {
          //set data
          set_profile_lastprofileup(response.data.row_result.lastprofileup);
          set_profile_fullname(response.data.row_result.fullname);
          set_profile_mobile(response.data.row_result.mobile);
          set_profile_accvalidtill(response.data.row_result.accvalidtill);
          set_profile_entrytime(response.data.row_result.entrytime);
          set_profile_lastaccess(response.data.row_result.lastaccess);
        } else {
          alert("Something went wrong. Try again.");
        }
      })
      .catch((error) => {
        //stopLoading
        stopLoading();
        console.log(error);
        alert("Something went wrong. Try again.");
      });
  }

  function showMyProfile() {
    return (
      <>
        <div className="container">
          <div className="row">
            <div className="col s12 m2 l3"></div>
            <div
              className="col s12 m8 l6 app_view_contain_remove"
              style={{ wordBreak: "break-word" }}
            >
              <center>
                <font className="font_sub_title">My Profile</font>
                <hr />
              </center>
              <font className="font_sub_small_content">Name :</font>
              <br />
              <font className="font_sub_small_title">{profile_fullname}</font>
              {/*<i
                className="fa fa-pencil fa-2x"
                style={{ cursor: "pointer" }}
                onClick={gotoeditprofile}
              ></i>*/}
              <br />
              <font className="font_sub_small_content">Mobile :</font>
              <br />
              <font className="font_sub_small_title">{profile_mobile}</font>
              <br />
              <font className="font_sub_small_content">
                Account valid till :
              </font>
              <br />
              <font className="font_sub_small_title">
                {moment(profile_accvalidtill).format("DD MMM YYYY")}
              </font>
              <ContactUs />
              <br />
              <font className="font_sub_small_content">
                Last Profile Update :
              </font>
              <br />
              <font className="font_sub_small_title">
                {moment(profile_lastprofileup).format("DD MMM YYYY hh:mm a")}
              </font>
              <br />
              <font className="font_sub_small_content">Register at :</font>
              <br />
              <font className="font_sub_small_title">
                {moment(profile_entrytime).format("DD MMM YYYY hh:mm a")}
              </font>
              <br />
              <font className="font_sub_small_content">Online at :</font>
              <br />
              <font className="font_sub_small_title">
                {moment(profile_lastaccess).format("DD MMM YYYY hh:mm a")}
              </font>
              <br />
              <br />
              <div
                className="font_sub_small_title div_but div_red center"
                onClick={signoutuser_confirm}
              >
                Logout
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  return (
    <React.Fragment>
      {showMyProfile()}
      <Navigation link_type="myprofile" />
    </React.Fragment>
  );
}

export default MyProfile;
